 angular.module("push_notifications_types")

    .controller("PushNotificationsTypesEditCtrl", ['LoginService', '$scope', '$rootScope', '$state', '$stateParams', 'Restangular', 'modalService','$filter', '$translate', function (LoginService, $scope, $rootScope, $state, $stateParams, Restangular, modalService, $filter, $translate) {

        //Comprobamos si tiene permiso escritura


        $scope.allowWrite = true// LoginService.permissionExist("MAILINGS_WRITE");

        $rootScope.title = $filter('translate')('push_notifications_types.title');

        $scope.push_notification_type = {};


        //Gestor de texto 
     

        if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {

            $rootScope.breadcrumb = [
                { title: $filter('translate')('push_notifications_types.title'), url: `push_notifications_types.list` },
                { title: $filter('translate')('push_notifications_types.add') },

            ];
        } else {
            $rootScope.breadcrumb = [
                { title: $filter('translate')('push_notifications_types.title'), url: `push_notifications_types.list` },
                { title: $filter('translate')('general.edit') },
            ];

            Restangular.one('PushNotifications/Types', $stateParams.id).get().then(function (result) {
                $scope.push_notification_type = result;
            });
        }

        $scope.save = function () {

            if (!angular.isUndefined($scope.push_notification_type.id)) {
                $scope.push_notification_type.put().then(function (result) {
                    if (typeof (result.id) != "undefined") {
                        toastr.success($filter('translate')('push_notifications_types.add_success'));
                        $state.go("push_notifications_types.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            } else {
                Restangular.all('PushNotifications/Types').post($scope.push_notification_type).then(function (result) {
                    if (typeof (result.id) != "undefined") {
                        toastr.success($filter('translate')('push_notifications_types.add_success'));
                        $state.go("push_notifications_types.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        }

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter('translate')('push_notifications_types.delete'),
                message: $filter('translate')('push_notifications_types.delete_message'),
                onAccept: function () {
                    $scope.push_notification_type.remove().then(function () {
                        toastr.success($filter('translate')('push_notifications_types.remove_success'));
                        $state.go("push_notifications_types.list");
                    });
                }
            });
        };



    }])

    ;

